import { DeliveriesRequestFilters, DeliveriesResponse } from 'api/models/Deliveries';
import { OrdersResponse } from 'api/models/Orders';
import theme from 'App.theme';

export enum TableTypes {
  DEFAULT = 'DEFAULT',
  CRITICAL_ITEMS = 'CRITICAL_ITEMS',
  RECEIVE_OVERDUE = 'RECEIVE_OVERDUE',
  CHECK_IN_OVERDUE = 'CHECK_IN_OVERDUE',
  CHECK_OUT_OVERDUE = 'CHECK_OUT_OVERDUE',
  ALL = 'ALL',
}

export enum ActionItemType {
  CriticalItems = 'CRITICAL_ITEMS',
  BookingsToBeConfirmed = 'BOOKINGS_TO_BE_CONFIRMED',
  DeliveriesToBeReceived = 'DELIVERIES_TO_BE_RECEIVED',
  DeliveriesToBeCheckedIn = 'DELIVERIES_TO_BE_CHECKED_IN',
  DeliveriesToBeCheckedOut = 'DELIVERIES_TO_BE_CHECKED_OUT',
}

export type ActionItem = {
  lang: {
    label: string;
    allClear: string;
  };
  colors: typeof theme.colors.statuses.DISPATCHED;
  tableType?: TableTypes;
  filters?: Partial<DeliveriesRequestFilters>;
  dataType?: 'deliveries' | 'orders';
};

export type ActionItems = Record<ActionItemType, ActionItem>;

export type ActionItemData<T> = {
  data?: T;
  isLoading: boolean;
  count: number;
  expressCount: number;
  total: number;
  search: string;
};

export type DeliveriesActionItemData = ActionItemData<DeliveriesResponse>;

export type OrdersActionItemData = ActionItemData<OrdersResponse>;

export type ActionItemsTotals = Record<ActionItemType, { total: number; expressCount: number }>;
